export var keyPrefix = 'officeHome';
export var officeUserSideloadDataCookieKeyFormat = "".concat(keyPrefix, "-{0}sideloadedApps");
export var m365AppsDataDivId = 'm365AppsData';
export var AppsWithBuiltInContentActions = {
    PDFWorks: 'ca4b5141-5c46-47bc-a05e-2733d9bd69aa',
    ToDo: '7d30d5c91ee-5be2-4b79-81ed-23e6c4580427',
};
export var jaguarsharkAppId = '07b75f22-72b5-4063-b7fc-0ed5ea8ff3ff';
//# sourceMappingURL=keys.js.map